export function htmlToPlainText(html?: string): string {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;


    let text = div.textContent || div.innerText || "";

    text = text.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();
    return text;
}

export function countLettersAndSpaces(html?: string): number {
    const text = htmlToPlainText(html);
    const onlyLettersAndSpaces = text.match(/[\p{L} ]/gu) ?? [];
    return onlyLettersAndSpaces.length;
}
